document.addEventListener("DOMContentLoaded", function () {
  var menuBtn = document.querySelector("[data-xb-menu]");
  var nav = document.querySelector("[data-xb-nav]");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      nav.style.display = open ? "flex" : "";
      if (open) {
        nav.style.flexDirection = "column";
        nav.style.position = "absolute";
        nav.style.top = "64px";
        nav.style.right = "16px";
        nav.style.background = "#0d1626";
        nav.style.padding = "14px 18px";
        nav.style.border = "1px solid rgba(255,255,255,0.08)";
        nav.style.color = "#f8fafc";
        nav.style.borderRadius = "12px";
        nav.style.minWidth = "220px";
      }
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = link.getAttribute("href").slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  var slider = document.querySelector("[data-xb-slider]");
  if (slider) {
    var slides = slider.querySelectorAll(".xb-slide");
    var dotsWrap = slider.querySelector("[data-xb-dots]");
    var index = 0;
    var timer;
    var wait = Number(slider.getAttribute("data-interval") || 6500);

    slides.forEach(function (_, i) {
      if (!dotsWrap) return;
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "xb-dot" + (i === 0 ? " is-on" : "");
      dot.setAttribute("aria-label", "Go to slide " + (i + 1));
      dot.addEventListener("click", function () {
        go(i);
        restart();
      });
      dotsWrap.appendChild(dot);
    });

    function paint() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle("is-on", i === index);
      });
      if (dotsWrap) {
        dotsWrap.querySelectorAll(".xb-dot").forEach(function (dot, i) {
          dot.classList.toggle("is-on", i === index);
        });
      }
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      paint();
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(function () {
        go(index + 1);
      }, wait);
    }

    var prev = slider.querySelector("[data-xb-prev]");
    var next = slider.querySelector("[data-xb-next]");
    if (prev) prev.addEventListener("click", function () { go(index - 1); restart(); });
    if (next) next.addEventListener("click", function () { go(index + 1); restart(); });

    slider.addEventListener("mouseenter", function () { clearInterval(timer); });
    slider.addEventListener("mouseleave", restart);
    restart();
  }

  var qtyBox = document.querySelector(".xb-qty");
  if (qtyBox) {
    var qtyInput = qtyBox.querySelector("input");
    qtyBox.querySelectorAll("[data-xb-qty]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = Number(qtyInput.value || 1) + Number(btn.getAttribute("data-xb-qty"));
        qtyInput.value = Math.max(1, Math.min(20, next));
      });
    });
  }

  document.querySelectorAll("[data-xb-gallery]").forEach(function (gallery) {
    var images = gallery.querySelectorAll(".xb-gallery-img");
    var thumbs = gallery.querySelectorAll("[data-xb-goto]");
    function show(index) {
      images.forEach(function (img, i) { img.classList.toggle("is-on", i === index); });
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle("is-on", i === index); });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function (event) {
        event.preventDefault();
        show(Number(thumb.getAttribute("data-xb-goto")));
      });
    });
  });

  var mainImg = document.querySelector("[data-xb-main] img");
  document.querySelectorAll("[data-xb-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImg) return;
      var nextSrc = thumb.getAttribute("data-xb-thumb");
      mainImg.src = nextSrc;
      mainImg.removeAttribute("srcset");
      mainImg.removeAttribute("sizes");
      document.querySelectorAll("[data-xb-thumb]").forEach(function (el) {
        el.classList.remove("is-on");
      });
      thumb.classList.add("is-on");
    });
  });

  var header = document.querySelector(".xb-header");
  if (header) {
    var paintHeader = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    paintHeader();
    window.addEventListener("scroll", paintHeader, { passive: true });
  }

  document.documentElement.style.setProperty("--header-height", "0px");
  document.body.style.setProperty("padding-top", "0px", "important");
  document.documentElement.style.setProperty("padding-top", "0px", "important");

  var reveals = document.querySelectorAll(".xb-reveal");
  reveals.forEach(function (el) { el.classList.add("is-in"); });

  var shop = document.querySelector("[data-xb-shop]");
  if (shop) {
    var handle = (new URLSearchParams(window.location.search).get("xb") || "").toLowerCase().trim();
    var labels = {
      condom: "Condom",
      condoms: "Condom",
      "timing-tablets": "Timing Tablets",
      tablets: "Timing Tablets",
      "timing-spray": "Timing Spray",
      spray: "Timing Spray",
      "timing-creams": "Timing Creams",
      creams: "Timing Creams",
      enlarge: "Enlarge"
    };
    function matches(hay, key) {
      hay = " " + (hay || "").toLowerCase() + " ";
      if (key === "condom" || key === "condoms") return hay.indexOf("condom") !== -1;
      if (key === "timing-tablets" || key === "tablets") return /tablet|sildenafil|tadalafil|vardenafil|18 again/.test(hay);
      if (key === "timing-spray" || key === "spray") return hay.indexOf("spray") !== -1;
      if (key === "timing-creams" || key === "creams") return hay.indexOf("cream") !== -1;
      if (key === "enlarge") return hay.indexOf("enlarg") !== -1;
      return key && hay.indexOf(key) !== -1;
    }
    if (handle && handle !== "all") {
      var shown = 0;
      shop.querySelectorAll("[data-xb-card]").forEach(function (card) {
        var ok = matches(card.getAttribute("data-xb-hay"), handle);
        card.style.display = ok ? "" : "none";
        if (ok) shown += 1;
      });
      var empty = shop.querySelector("[data-xb-empty]");
      if (empty) empty.hidden = shown > 0;
      var title = document.querySelector("[data-xb-shop-title]");
      if (title) title.textContent = labels[handle] || handle.replace(/-/g, " ");
      var lead = document.querySelector(".xb-shophead .xb-col-lead");
      if (lead) lead.textContent = (labels[handle] || "These") + " products, delivered in plain packaging.";
      document.querySelectorAll(".xb-chip").forEach(function (chip) {
        var href = chip.getAttribute("href") || "";
        var chipKey = "";
        try { chipKey = new URL(chip.href, window.location.origin).searchParams.get("xb") || ""; } catch (e) {}
        if (!chipKey && href.indexOf("xb=") === -1) chipKey = "all";
        chip.classList.toggle("is-on", chipKey === handle || (handle === "condom" && chipKey === "condoms"));
      });
    }
  }
});
